<template>
  <div>

    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push('/navigation')"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-6">
        <q-btn
          @click="saveChanges(false)"
          style="float: right"
          class="capitalize ctrl-button right"
          :color="'ctrl-turquoise'"
          :label="`${$store.state.stringsStore.strings.action.save}`"
          icon-right="save"
        />
      </div>
    </div>

    <div class="row gutter-sm">
      <!-- Left column -->
      <div class="col-md-6 col-sm-12 col-xs-12">

        <p class="card-title">Menu</p>
        <div class="card-block">

          <!-- title -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.title"
              :float-label="getString('title')">
            </q-input>
          </q-field>

          <!-- code -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.code"
              :readonly="!!$route.params.id"
              float-label="Code">
            </q-input>
          </q-field>

        </div>

        <q-btn v-if="$route.params.id"
          class="capitalize ctrl-button q-mt-md"
          color="primary"
          :label="'Items'"
          @click="$router.push(`/navigation/${$route.params.id}/items`)"
          icon="remove_red_eye"
        />

      </div>
    </div>
  </div>
</template>

<script>
import getString from '@/helpers/GetStrings';
import saveChanges from '@/mixins/detailViews/saveChanges';

export default {

  data() {
    return {
      endpoint: 'navigation',
      module: 'navigation.menu',
      data: {
        code: '',
        title: '',
      },
    };
  },

  mixins: [saveChanges],

  methods: {
    getString,

    getMenu() {
      this.axios.get(`navigation/${this.$route.params.id}`).then((res) => {
        this.data = res.data.menu;
      });
    },

    requestParams() {
      return {
        code: this.data.code,
        title: this.data.title,
      };
    },
  },

  mounted() {
    // Get data if the menu item already exists.
    if (this.$route.params.id) {
      this.getMenu();
    }
  },
};
</script>

<style lang="stylus">
  .new-node
    background #71CFED17
    border: 1px solid var(--q-color-primary);
    margin-bottom: 5px;
    padding: 5px;

  .tree-node
    cursor pointer
    span
      display block
      width 100%

 .menu
   &__new-item
    text-align center
    margin-top 10px
    padding 10px
    color #fff
    background var(--q-color-primary)
    border 1px solid #71CFED17
    border-radius 5px
    cursor pointer

.submenu
  &__item
    cursor pointer
    padding 10px
    font-weight bold
    background #71CFED17
    border 1px solid var(--q-color-primary)
    border-radius 3px
    margin-bottom 2px

</style>
